import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import iconrightgreen from '../../../image/iconrightgreen.svg'
import HandleRes from '../Components/HandleRes/HandleRes';
import  smartphone  from '../../../image/smartphone.svg'
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
class CourierConfirmPhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            codeError: "",
            sendcode:false,
            res_sendcodedone:false,
            networkError: false,
            errordataCodemessage: false,
            errordatamessageCodetext: '',
            hasError: false,


        }
    }
    
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };

    validate = () => {
        let codeError = "";

        if (this.state.code.length !== 4||isNaN(this.state.code)) {
            codeError = "اكتب الرمز صحيح";
        }
        if (codeError) {
            this.setState({ codeError});
            return false;
        }
        return true;
    };
    resendcode=()=>{
        const Token =localStorage.getItem("userTokentConfirmData")
        axios.put(`${LinkAPI}/api/businessowner/resendcode`,{},{
            headers:{
              Authorization:`${Token}`,
              lang:"ar"
            }
          }).then(res =>{
            this.setState({
               sendcode:true,
               res_sendcodedone:true,

              })
              setTimeout(() => {
                this.setState({
                    res_sendcodedone:false
                })
        }, 2000);
              }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                }   else if (error.response.status === 402) {
                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
              })
    } 
    handleSubmit = event => {
        event.preventDefault();
        const {code}= this.state
        const Token =localStorage.getItem("userTokentConfirmData")
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/courier/compleatesignup`,{code:code},{
                headers:{
                  Authorization:`${Token}`,
                  lang:"ar"
                }
              }
              ).then(res =>{
                this.setState({
                    res_done: true,
                })
                localStorage.setItem("userTokentConfirmData","")

                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                }  else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })        
            }
    };
    render() {
        document.title ="kayn | تاكيد رقم الهاتف  ";
      document.getElementsByTagName("META")[1].content="كاين | تاكيد رقم الهاتف    ";
      document.documentElement.lang = 'ar';
        return (
            <div className="AppAR ConfirmData">
                <Navbar />
                <div className='container'>
                    <div className="Sign  row">
                        
                        <div className="col-md-6 form text-center p-lg-5 ">
                        

                        {!this.state.res_done ?
                                <form className="mt-5 " onSubmit={this.handleSubmit}>
                                    <div className="py-5 ">
                                        <div className="mt-5  px-lg-5 nocounter">
                                        <img className="mt-2 warningimg" src={smartphone} alt="smartphone" /><br/>

                                            <label className="text-muted fontsize12">قم بتاكيد رقم الهاتف</label>
                                            <input type="number" className={"form-control badge-pill p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="ادخل الرمز الذي تم ارساله لرقم الهاتف " name="code" onChange={this.handleChange} value={this.state.code} />
                                        </div>
                                        <div style={{ fontSize: 12, color: "red", }}>
                                            {this.state.codeError}
                                        </div>{(this.state.errordatamessage ?
                                            <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.errordatamessageText}
                                            </div> : '')}
                                            {this.state.sendcode?'':<p className="pointer fontsize11 text-muted py-1 my-1" onClick={this.resendcode}>ارسال الرمز مره اخري؟</p>}

                                    </div>

                                    <button type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow btn-primary" >تاكيد</button>
                                </form> :
                                <div className=" mx-auto  text-center textconfirm">
                                    <img className="mt-2 warningimg" src={iconrightgreen} alt="warning" />
                                    <p className="fontsize9 py-2">تم التاكد من رقم الهاتف <br/> سوق يتم التواصل معك قريبا</p>
                                </div>}



                        
                        </div>
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
                        </div>
                    </div>
                </div>
                {(this.state.res_sendcodedone ? <HandleRes title="Massage has been sent" stylecss="alert-success" /> : '')}

            {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default CourierConfirmPhone;